"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * REST Server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetToJSON = exports.AssetFromJSONTyped = exports.AssetFromJSON = exports.instanceOfAsset = void 0;
var runtime_1 = require("../runtime");
var AssetActionClassSummariesInner_1 = require("./AssetActionClassSummariesInner");
var OSInfo_1 = require("./OSInfo");
/**
 * Check if a given object implements the Asset interface.
 */
function instanceOfAsset(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAsset = instanceOfAsset;
function AssetFromJSON(json) {
    return AssetFromJSONTyped(json, false);
}
exports.AssetFromJSON = AssetFromJSON;
function AssetFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'ip': !(0, runtime_1.exists)(json, 'ip') ? undefined : json['ip'],
        'deviceName': !(0, runtime_1.exists)(json, 'deviceName') ? undefined : json['deviceName'],
        'userDeviceName': !(0, runtime_1.exists)(json, 'userDeviceName') ? undefined : json['userDeviceName'],
        'mac': !(0, runtime_1.exists)(json, 'mac') ? undefined : json['mac'],
        'osInfo': !(0, runtime_1.exists)(json, 'osInfo') ? undefined : (0, OSInfo_1.OSInfoFromJSON)(json['osInfo']),
        'risk': !(0, runtime_1.exists)(json, 'risk') ? undefined : json['risk'],
        'vulns': !(0, runtime_1.exists)(json, 'vulns') ? undefined : json['vulns'],
        'lastVerifiedDeviceName': !(0, runtime_1.exists)(json, 'lastVerifiedDeviceName') ? undefined : json['lastVerifiedDeviceName'],
        'lastVerifiedMac': !(0, runtime_1.exists)(json, 'lastVerifiedMac') ? undefined : json['lastVerifiedMac'],
        'lastVerifiedOs': !(0, runtime_1.exists)(json, 'lastVerifiedOs') ? undefined : json['lastVerifiedOs'],
        'lastScannedTime': !(0, runtime_1.exists)(json, 'LastScannedTime') ? undefined : json['LastScannedTime'],
        'manufacturer': !(0, runtime_1.exists)(json, 'manufacturer') ? undefined : json['manufacturer'],
        'sessionQualifier': !(0, runtime_1.exists)(json, 'sessionQualifier') ? undefined : json['sessionQualifier'],
        'clientUUID': !(0, runtime_1.exists)(json, 'clientUUID') ? undefined : json['clientUUID'],
        'userName': !(0, runtime_1.exists)(json, 'userName') ? undefined : json['userName'],
        'externalIP': !(0, runtime_1.exists)(json, 'externalIP') ? undefined : json['externalIP'],
        'latitude': !(0, runtime_1.exists)(json, 'latitude') ? undefined : json['latitude'],
        'longitude': !(0, runtime_1.exists)(json, 'longitude') ? undefined : json['longitude'],
        'city': !(0, runtime_1.exists)(json, 'city') ? undefined : json['city'],
        'country': !(0, runtime_1.exists)(json, 'country') ? undefined : json['country'],
        'timeZone': !(0, runtime_1.exists)(json, 'timeZone') ? undefined : json['timeZone'],
        'anonymousProxy': !(0, runtime_1.exists)(json, 'anonymousProxy') ? undefined : json['anonymousProxy'],
        'satelliteProvider': !(0, runtime_1.exists)(json, 'satelliteProvider') ? undefined : json['satelliteProvider'],
        'lastVerifiedExternalIP': !(0, runtime_1.exists)(json, 'lastVerifiedExternalIP') ? undefined : json['lastVerifiedExternalIP'],
        'systemModel': !(0, runtime_1.exists)(json, 'systemModel') ? undefined : json['systemModel'],
        'systemBootTime': !(0, runtime_1.exists)(json, 'systemBootTime') ? undefined : json['systemBootTime'],
        'active': !(0, runtime_1.exists)(json, 'active') ? undefined : json['active'],
        'ridaRiskLink': !(0, runtime_1.exists)(json, 'ridaRiskLink') ? undefined : json['ridaRiskLink'],
        'hostID': !(0, runtime_1.exists)(json, 'hostID') ? undefined : json['hostID'],
        'category': !(0, runtime_1.exists)(json, 'category') ? undefined : json['category'],
        'scannerUUID': !(0, runtime_1.exists)(json, 'scannerUUID') ? undefined : json['scannerUUID'],
        'deploymentID': !(0, runtime_1.exists)(json, 'deploymentID') ? undefined : json['deploymentID'],
        'source': !(0, runtime_1.exists)(json, 'source') ? undefined : json['source'],
        'actionClassSummaries': !(0, runtime_1.exists)(json, 'actionClassSummaries') ? undefined : (json['actionClassSummaries'].map(AssetActionClassSummariesInner_1.AssetActionClassSummariesInnerFromJSON)),
        'criticality': !(0, runtime_1.exists)(json, 'criticality') ? undefined : json['criticality'],
        'tags': !(0, runtime_1.exists)(json, 'tags') ? undefined : json['tags'],
    };
}
exports.AssetFromJSONTyped = AssetFromJSONTyped;
function AssetToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'ip': value.ip,
        'deviceName': value.deviceName,
        'userDeviceName': value.userDeviceName,
        'mac': value.mac,
        'osInfo': (0, OSInfo_1.OSInfoToJSON)(value.osInfo),
        'risk': value.risk,
        'vulns': value.vulns,
        'lastVerifiedDeviceName': value.lastVerifiedDeviceName,
        'lastVerifiedMac': value.lastVerifiedMac,
        'lastVerifiedOs': value.lastVerifiedOs,
        'LastScannedTime': value.lastScannedTime,
        'manufacturer': value.manufacturer,
        'sessionQualifier': value.sessionQualifier,
        'clientUUID': value.clientUUID,
        'userName': value.userName,
        'externalIP': value.externalIP,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'city': value.city,
        'country': value.country,
        'timeZone': value.timeZone,
        'anonymousProxy': value.anonymousProxy,
        'satelliteProvider': value.satelliteProvider,
        'lastVerifiedExternalIP': value.lastVerifiedExternalIP,
        'systemModel': value.systemModel,
        'systemBootTime': value.systemBootTime,
        'active': value.active,
        'ridaRiskLink': value.ridaRiskLink,
        'hostID': value.hostID,
        'category': value.category,
        'scannerUUID': value.scannerUUID,
        'deploymentID': value.deploymentID,
        'source': value.source,
        'actionClassSummaries': value.actionClassSummaries === undefined ? undefined : (value.actionClassSummaries.map(AssetActionClassSummariesInner_1.AssetActionClassSummariesInnerToJSON)),
        'criticality': value.criticality,
        'tags': value.tags,
    };
}
exports.AssetToJSON = AssetToJSON;
